import { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from "react-router-dom"
import parse from 'html-react-parser';
import fetchJsonp from 'fetch-jsonp';
// styles
import styles from "./LeadCaptureOrder.module.css"
// ------ Components ------ //
import LoadingSpinner from "../../Miscellaneous/LoadingSpinner"
const PayForm = () => {
    const location = useLocation();
    const navigate = useNavigate()
    const payForm = location.state;
    const [paidAlready, setPaidAlready] =
        useState(payForm.paidAlready && payForm.paidAlready === true ? true : false);
    const [loaded, setLoaded] = useState(false);
    const [paymentCompleted, setPaymentCompleted] = useState(false);
    const [confirmationRedirect, setConfirmationRedirect] = useState(false);
    const [paymentUnavailable, setPaymentUnavailable] = useState(false);
    const [paypalPayment, setPaypalPayment] = useState(false);
    const monitorRef = useRef(true);
    const checkForPaymentAdded = async (initialCheck) => {
        let urlHolder = '';
        if (initialCheck || monitorRef.current)  // DS testing
        {
            urlHolder = payForm.paymentUrl;
        }
        else {
            urlHolder = 'https://pci.prod.itswebs.com/payflow/ispaymentadded/6efb214a-fea8-489a-a3df-8b7ddd1b486e';
        }
        //const url = urlHolder;
        //const url = 'https://pci.prod.itswebs.com/payflow/ispaymentadded/6efb214a-fea8-489a-a3df-8b7ddd1b486e';// payForm.paymentUrl; //
        try {
            let json = '';
            const response = await fetchJsonp(urlHolder,
                {
                    timeout: 3000,
                    jsonpCallback: "callback"
                }, 2000
            )
                .then(function (response) {
                    if (response.ok === true) {
                        return response.json();
                    }
                    else {
                        return null;
                    }
                   
                })
                .then(function (parsedJson) {
                    if (parsedJson) {
                        json = parsedJson.result;
                    }
                    else {
                        json = 'False';
                    }
                    //console.log("parsed parsedJson ", parsedJson);
                })
                .catch(function (ex) {
                    //console.log("parsing failed for payment url", ex);
                });
            // hide
            setPaymentUnavailable(false);
            // show
            setPaypalPayment(true);
            if (json === 'True')
            {
                //Make sure payment options are visible if the json call is successful
                //Stop the database polling
                setPaidAlready(true);
                if (initialCheck === false || monitorRef.current === false) {
                    //Submit the form to begin post payment processing
                    // show
                    setConfirmationRedirect(true);
                    // trigger submission
                    await handleSubmit();
                }
                else {
                    // show
                    setPaymentCompleted(true);
                    // hide
                    setPaypalPayment(false);
                }
            }
            monitorRef.current = false;
        } catch (error) {
            console.error(error.message);
            // show
            setPaymentUnavailable(true);
            // hide
            setPaypalPayment(false);
        }
    }

    const handleSubmit = async e => {
        //e.preventDefault()
        try {
            // go to confirmation page
            // pass invoiceid, pull info and display - use what was returned?
            navigate('/Confirmation', { state: payForm });

        } catch (err) {
            //setMessage(err.message)
        }
    }
    useEffect(() => {
        const interval = setInterval(() => {
            checkForPaymentAdded(monitorRef.current);
        }, 3.5 * 1000); // don't want calls to startup again
        return () => clearInterval(interval);
    }, []);
    useEffect(() => {
        //See if payment has already been made immediately after the page loads.
        //If the initial check is true, chances are they just back buttoned - do not resubmit
        monitorRef.current = true;
        // Initial check to see if paid
        checkForPaymentAdded();
        setLoaded(true)
    }, [])
    return (
        <>{!loaded ? <LoadingSpinner /> :
            <div>
                <h2>Payment</h2><br/>
                <br />
                <p><strong>Payment amount: {payForm.amount}</strong></p>
                <div>
                    {paidAlready && paidAlready === true ?
                        <div class="alert alert-info">
                            You have already paid.
                        </div>
                        :
                        <>
                            {
                                paymentCompleted && paymentCompleted === true ?
                                    <div id="divPaymentCompleted" class="alert alert-info">
                                        Payment completed.<br />Thank you.
                                    </div>
                                    : <> </>
                            }

                            {
                                confirmationRedirect && confirmationRedirect === true ?
                                    <div id="divConfirmationRedirect" class="alert alert-info">
                                        {/*Display while credit card is being processed*/}
                                        Processing, please wait...
                                    </div>
                                    : <> </>
                            }
                            
                            {
                                paymentUnavailable && paymentUnavailable === true ? 
                                <div id="divPaymentUnavailable" class="alert alert-info" >
                                    {/*Show this if the polling service is not responding*/}
                                    Payment screen loading.  Please wait....
                                </div>
                                : <> </>
                            }

                            {
                                paypalPayment && paypalPayment === true ?
                                    <div id="divPaypalPayment" >
                                        <h4>Please complete payment process.</h4>
                                        {/*Where the paypal form is generated*/}
                                        {
                                            payForm.payFormHtml ?
                                            <>
                                                <iframe
                                                    title="paypal_iframe"
                                                    width="740px"
                                                    height="650px"
                                                        overflow="hidden"
                                                        scroll="no"
                                                    srcDoc={payForm.payFormHtml}
                                                ></iframe>
                                            </>
                                             :
                                            <div>Error in payment html...</div>
                                        }
                                    </div>
                                    : <> </>
                            }

                        </>
                    }
                    <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                </div>


        </div>
          
            
        }
        </>


    );
}
export default PayForm;